export default {
  wrapper: {
    margin: '0 16px',
    position: 'relative'
  },
  label: {
    transform: 'translateX(-50%)'
  }
};